/**
 * Server-side Playwright print surface — short-lived print token only.
 * Route: /tree/:treeId/legacy-book-print?token=...
 */
import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { getApiBase } from '../utils/apiBase';
import { TreeLegacyBookPrintLayout } from '../components/legacy-book/TreeLegacyBookPrintLayout';
import '../components/legacy-book/legacy-book-preview.css';

const API = getApiBase();

export default function TreeLegacyBookPrintExportPage() {
  const { treeId } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!treeId || !token) {
        if (!cancelled) {
          setError('missing_token');
          setLoading(false);
        }
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`${API}/trees/${treeId}/legacy-book-data`, {
          headers: { 'X-Legacy-Book-Print-Token': token },
        });
        if (!cancelled) setData(res.data);
      } catch {
        if (!cancelled) setError('load_failed');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [treeId, token]);

  if (loading) {
    return (
      <div className="legacy-book-preview-root" data-testid="legacy-book-print-loading">
        <p className="sr-only">Preparing Legacy Book for print…</p>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="legacy-book-preview-root" data-testid="legacy-book-print-error">
        <p className="sr-only">Unable to load Legacy Book for print.</p>
      </div>
    );
  }

  return (
    <div
      className="legacy-book-preview-root tree-legacy-book-print-export"
      data-theme="heritage"
      data-testid="legacy-book-print-ready"
    >
      <TreeLegacyBookPrintLayout data={data} />
    </div>
  );
}
